import axios from 'axios';
import getHeaders from '../../constants/headers';
import { BRAND_BASE_URL } from '../BaseURL';


export const getCustomerOldOrderLedger = (brandId, data) => {
    return axios({
      method: 'post',
      url:
      BRAND_BASE_URL +
        '/brand/api/secure/v1/old-order/' +
        brandId +
        '/ledger', // for android use
      headers: getHeaders(),
      data: JSON.stringify(data),
    });
  };
 

  export const updateCustomerOldOrderLedger = (brandId, data) => {
    return axios({
      method: 'put',
      url:
      BRAND_BASE_URL +
      '/brand/api/secure/v1/old-order/' +
      brandId +
      '/order',  // for android use
      headers: getHeaders(),
      data: JSON.stringify(data),
    });
  };
 